// UTBMS-style activity codes for time entries.  Single source of truth —
// replaces the four duplicated arrays that used to live in Layout.js,
// TimeEntries.js, MatterDetail.js, and (formerly) FloatingTimer.js.
//
// The L### codes are UTBMS Litigation Task Codes; ADMIN + OTHER are firm
// additions for internal/administrative time and catch-all cases.  Values
// are stored in the database as `time_entries.activity_code`; changing a
// code here without a migration would orphan historical entries under
// their old code — labels are safe to change, codes are not.
//
// Sorted alphabetically by label so the dropdown is browsable, with ADMIN
// and OTHER interleaved by their labels.

export const ACTIVITY_CODES = [
  { code: 'ADMIN', label: 'Administrative' },
  { code: 'L120',  label: 'Analysis/Strategy' },
  { code: 'L510',  label: 'Appeal Preparation' },
  { code: 'L520',  label: 'Appellate Motions/Submissions' },
  { code: 'L150',  label: 'Budgeting' },
  { code: 'L260',  label: 'Class Action Certification' },
  { code: 'L230',  label: 'Court Mandated Conferences' },
  { code: 'L330',  label: 'Depositions' },
  { code: 'L350',  label: 'Discovery Motions' },
  { code: 'L240',  label: 'Dispositive Motions' },
  { code: 'L320',  label: 'Document Production' },
  { code: 'L140',  label: 'Document/File Management' },
  { code: 'L340',  label: 'Expert Discovery' },
  { code: 'L420',  label: 'Expert Witnesses' },
  { code: 'L130',  label: 'Experts/Consultants' },
  { code: 'L110',  label: 'Fact Investigation/Development' },
  { code: 'L410',  label: 'Fact Witnesses' },
  { code: 'L440',  label: 'Jury Selection' },
  { code: 'L530',  label: 'Oral Argument' },
  { code: 'OTHER', label: 'Other' },
  { code: 'L590',  label: 'Other Appeals' },
  { code: 'L190',  label: 'Other Case Assessment' },
  { code: 'L390',  label: 'Other Discovery' },
  { code: 'L290',  label: 'Other Pretrial Motions' },
  { code: 'L490',  label: 'Other Trial' },
  { code: 'L250',  label: 'Other Written Motions/Submissions' },
  { code: 'L210',  label: 'Pleadings' },
  { code: 'L470',  label: 'Post-Trial Motions' },
  { code: 'L220',  label: 'Preliminary Injunctions/TROs' },
  { code: 'L160',  label: 'Settlement/Non-Binding ADR' },
  { code: 'L460',  label: 'Trial Attendance' },
  { code: 'L450',  label: 'Trial Preparation' },
  { code: 'L310',  label: 'Written Discovery' },
  { code: 'L430',  label: 'Written Submissions (Trial)' }
]

// Human-readable label for a stored code.  Returns '—' for empty; falls
// back to the raw code if it isn't in the list (defensive for historical
// entries under codes that were later removed).
export function getActivityLabel(code) {
  if (!code) return '—'
  const found = ACTIVITY_CODES.find((ac) => ac.code === code)
  return found ? found.label : code
}

// Code AND name, for reports: 'L140' → 'L140 Document/File Management'.
// Reports print this so a reader needn't know the code list by heart (the
// user manual's activity-codes page lists them all).  Blank (null, '' or
// whitespace) → '—'.  A code that isn't in the list (typed into a CSV import,
// or retired) prints exactly as stored — never guessed at, never dropped.
// Matching ignores case and surrounding spaces, and prints the canonical code.
export function formatActivity(code) {
  const raw = code == null ? '' : String(code).trim()
  if (!raw) return '—'
  const upper = raw.toUpperCase()
  const found = ACTIVITY_CODES.find((ac) => ac.code === upper)
  return found ? `${found.code} ${found.label}` : raw
}
